<template>
    <!-- 消息通知详情 -->
    <div  class="Booking">
    <TopNavigation  class="topNavigation"></TopNavigation>
    <div class="typeArea">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/Message' }">消息通知</el-breadcrumb-item>
            <el-breadcrumb-item class="bread">消息通知详情</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="content">
            <div v-if="type==1">
                <div class="tit">
                    {{form.pol_name}} 到 {{form.pod_name}}
                </div>
                
                <div class="detail">
                    {{form.box_quantity_desc}}
                </div>
                <div class="detail">{{form.content}}</div>
                <div class="time">
                    {{form.create_time}}
                </div>
            </div>
            <div v-else>
                <div class="tit">
                    国家:<span class="fense">{{form.country_name}}</span>  
                    城市名称:<span class="fense">{{form.end_city_name}} </span>
                    卸货港、卸货地 | 装货港、装货地:<span class="fense">{{form.port_name}} </span>
                    进出口:<span class="fense">{{form.type_desc}} </span>
                </div>
                
                <div class="detail">
                    {{form.username}}({{form.email}})
                </div>
                <div class="detail">{{form.content}}</div>
                <div class="time">
                    {{form.create_time}}
                </div>
            </div>
            
            <div class="louyan">
                <div class="neir">
                    <el-avatar :src="avatar"></el-avatar>
                    <div>
                        <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入"
                        class="word"
                        @blur="handleInputBlur"
                        @focus="closeReplyBox"
                        v-model="newMessage">
                        </el-input>
                        <!-- @focus="closeReplyBox" -->
                        
                        <div class="fabiao">
                            <el-popover v-model="visibleEmoji" trigger="click">
                                <VEmojiPicker :showSearch="false" @select="selectEmoji" />
                                <i slot="reference" class="fa fa-smile-o"></i>
                            </el-popover>
                            <el-button  :disabled="!newMessage.trim()" @click="publishMessage">发表留言</el-button>
                        </div>
                    </div>
                </div>
                
            </div>
            <!-- 留言列表 -->
            <div class="yifabu" v-for="(item,index) in liuyanList" :key="index">
                <div class="liuyan">
                    <!-- 留言内容 -->
                    <div class="leftr">
                        <el-avatar v-if="item.self_type==1" :src="item.user_info.avatar" icon="el-icon-user-solid"></el-avatar>
                        <el-avatar v-if="item.self_type==2" :src="item.user_info.kefu_avatar" icon="el-icon-user-solid"></el-avatar>
                        <div class="info">
                            <div class="namen">
                                <span v-if="item.self_type==1">{{item.user_info.username}}</span>
                                <span v-if="item.self_type==2">{{item.user_info.kefu_name}}</span>
                                <span class="shijian">{{item.create_time}}</span>
                            </div>
                            <div class="hua">
                                {{item.content}}
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <!-- @click="zhanshi==index" -->
                        <el-button @click="reply(index)" type="text">回复</el-button>
                    </div>
                </div>

                <!-- 回复的留言 -->
                <div >
                    <div class="huifuliuyan" v-if="item.reply_info.content != undefined">
                        {{item.reply_info.user_info.kefu_name || item.reply_info.user_info.username}}：
                        {{item.reply_info.content}}
                    </div>
                </div>

                <!-- 回复留言  留言框 -->
                <div  v-if="replyIndex === index" class="huifu">
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入"
                        class="word"
                        @blur="handleInputBlurChild"
                        v-model="replyMessage">
                        </el-input>
                    <div class="fabiao">
                        <el-button class="quxiao" @click="cancelReply">取消</el-button>
                        <el-button :disabled="!replyMessage.trim()" @click="submitReply(item.id)">发表留言</el-button>
                        <el-popover v-model="visibleEmojiChild" trigger="click">
                            <VEmojiPicker :showSearch="false" @select="selectEmojiChild" />
                            <i slot="reference" class="fa fa-smile-o"></i>
                        </el-popover>
                    </div>
                </div>
            </div>

            <el-pagination
            v-show="total>0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNo"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
            </el-pagination>
        </div>
    </div>
    <Bottom />
    </div>
</template>
    
<script>
import { 
    shipRecordDetail,
    shipRecordReplyLists,
    shipRecordReply,
    mjdmRecordDetail,
    mjdmRecordReplyLists,
    mjdmRecordReply,
    unReadNum
} from "@/api/api";
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
export default {
    components:{
        Bottom,
        TopNavigation,
    },
    data() {
        return {
            form:{},

            total:0,
            pageNo:1,
            pageSize:10,
            textarea:'', 
            // 回复框显示
            zhanshi: false,
            avatar:JSON.parse(localStorage.getItem('userInfo')).avatar,
            replyIndex: null, // 当前回复框的索引
            newMessage: "", // 新留言内容
            replyMessage: "", // 回复内容
            headers:{
                token: localStorage.getItem('token')
            },
            liuyanList:[], // 留言列表

            type:1,  // 1 舱位留言   2 美加留言

            // 表情
            inputValue: "",
            blurPos: undefined,
            blurPosChild:undefined,

            visibleEmoji: false,
            visibleEmojiChild: false,
        }
    },
    methods: {
        async getDetail(){
            try {
                let api = shipRecordDetail
                if( this.type == 2){
                    api = mjdmRecordDetail
                }

                const res = await api({
                    record_id:this.$route.query.id
                },this.headers)
                if(res.code==1){
                    this.form = res.data
                    this.boxtype = res.data.boxtype
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 富文本处理
        showHtml(str) {
            return str
                .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'")
                .replace(/&amp;nbsp;/g, "\u3000");
        },
        // 调用接口  获取未读数量
        async getUnReadNum(){
            try {
                const res = await unReadNum({token:localStorage.getItem('token')})
                let storedObject = localStorage.getItem('userInfo');
                if (storedObject) { 
                    let obj = JSON.parse(storedObject);
                    obj.unread_num = res.data.unread_num;
                    localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                    // location.reload()  // 修改本地存储  刷新页面
                }      
            } catch (error) {
                console.log(error,'失败');
            }
        },
        chakan(){   
            if(this.form.send_type==6){ // 6去订舱  舱位确认
                let id = this.form.shipping_space_info.shipping_space_id
                this.$router.push('Booking?id='+id)
                // 跳转到订舱页  
            }else if(this.form.send_type==2 && this.form.notice_type==1){ // 查看订单详情
                // send_type==2 && notice_type==1 订舱订单，order_id，订单id
                if(this.form.order_info.order_id!=undefined){
                    this.$router.push({
                        name:'OrderDetails',
                        query:{
                            id:this.form.order_info.order_id
                        },
                        params:{
                            id:this.form.order_info.order_id
                        }
                    })
                }
            }
        },
        // 获取留言列表
        async getLiuyanLists(){
            try {
                let api = shipRecordReplyLists
                if(this.type==2){
                    api = mjdmRecordReplyLists
                }

                const res = await api({
                    record_id: this.$route.query.id,
                    page_no:this.pageNo,
                    page_size:this.pageSize
                },this.headers)
                if(res.code==1){
                    this.liuyanList = res.data.lists
                    this.total = res.data.count
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val
            this.getLiuyanLists()
        },
        handleCurrentChange(val) {
            this.pageNo = val
            this.getLiuyanLists()
        },
        reply(index){
            this.replyIndex = index;
            this.replyMessage = '' //清空回复框内容
        },
        // 取消回复
        cancelReply() {
            this.replyIndex = null;
            this.replyMessage = "";
        },
        // 关闭回复框
        closeReplyBox() {
            setTimeout(() => {
                this.replyIndex = null; // 确保回复框关闭
            }, 0);
        },
        // 发表留言
        async publishMessage(){
            if (!this.newMessage.trim()) return;
            try {
                let api = shipRecordReply
                if(this.type==2){
                    api = mjdmRecordReply
                }

                const res = await api({
                    record_id: this.$route.query.id,
                    reply_id:'',
                    content:this.newMessage.trim()
                },this.headers)
                if(res.code==1){
                //     this.liuyanList = res.data.lists
                    this.getLiuyanLists()
                    this.newMessage=''
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 回复留言
        async submitReply(index){
            if (!this.replyMessage.trim()) return;
            try {
                let api = shipRecordReply
                if(this.type==2){
                    api = mjdmRecordReply
                }

                const res = await api({
                    record_id: this.$route.query.id,
                    reply_id:index,
                    content:this.replyMessage.trim()
                },this.headers)
                if(res.code==1){
                //     this.liuyanList = res.data.lists
                    this.getLiuyanLists();
                    this.replyIndex = null;
                    this.replyMessage=''
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 表情
        handleInputBlur(e) {
            this.blurPos = e.srcElement.selectionStart;
        },
        handleInputBlurChild(e) {
            this.blurPosChild = e.srcElement.selectionStart;
        },
        selectEmoji(emoji) {
            if (this.newMessage === undefined) {
                this.newMessage = emoji.data;
            } else if (
                this.blurPos === undefined ||
                this.blurPos === this.newMessage.length
            ) {
                this.newMessage = `${this.newMessage}${emoji.data}`;
            } else {
                this.newMessage =
                this.newMessage.slice(0, this.blurPos) +
                emoji.data +
                this.newMessage.slice(this.blurPos);
            }
            this.visibleEmoji = false;
        },
        selectEmojiChild(emoji) {
            if (this.replyMessage === undefined) {
                this.replyMessage = emoji.data;
            } else if (
                this.blurPosChild === undefined ||
                this.blurPosChild === this.replyMessage.length
            ) {
                this.replyMessage = `${this.replyMessage}${emoji.data}`;
            } else {
                this.replyMessage =
                this.replyMessage.slice(0, this.blurPosChild) +
                emoji.data +
                this.replyMessage.slice(this.blurPosChild);
            }
            this.visibleEmojiChild = false;
        }
    },
    mounted(){
        this.type = this.$route.query.type
        this.getDetail()
        this.getLiuyanLists()
        // this.getUnReadNum()
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}


.el-breadcrumb{
    margin: 20px 0;
}

:deep(.el-breadcrumb) {
    .el-breadcrumb__inner {
        color: #999999;
    }
    .bread,.bread:hover {
        span {
            color: #D9276D;
        }
    }
}

.content{
    // height: 637px;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;
    padding: 32px;

    box-sizing: border-box;

    margin-bottom: 32px;
    .tit{
        font-family: PMedium;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;
    }

    .fense{
        color: #D9276D;
        margin-right: 12px;
    }

    .time{
        font-family: PMedium;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;

        margin-top: 12px;
        margin-bottom: 20px;
    }

    .detail{
        font-family: PMedium;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        font-style: normal;
        text-transform: none;
        overflow-wrap: break-word;
        word-break: break-all;
        margin-top: 12px;
    }
}

.boxDetail{
    margin-top: 24px;
    .boxtitle{
        font-weight: 600;
        font-family: PMedium;
    }
    .el-table{
        margin-top: 12px;
    }
}

.qudingcang{
    font-size: 18px;
    color: #FFFFFF;
    margin-top: 24px;
    width: 211px;
    height: 49px;
    background: #D9276D;
    border-radius: 4px 4px 4px 4px;
    
    .qdc{
        display: flex;
        align-items: center;
        justify-content: center;

        img{
            margin-left: 4px;
            width:20px;
            height: 20px;
        }
    }
}

.louyan{
    margin-top: 24px;
    .neir{
        display: flex;
        width: 100%;
    }
    .el-avatar{
        width: 40px;
        height: 40px;
        margin-right: 32px;
    }
    :deep(.el-textarea){
        width: 900px;
        height: 160px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        textarea{
            width: 900px;
            height: 160px;
            background: #F9F9F9;
            border: 0;
        }
    }
}

.yifabu{
    
    margin-top: 34px;
    margin-bottom: 32px;

    .liuyan{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .leftr{
        display: flex;
        align-items: center;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;
        .el-avatar{
            margin-right: 12px;
        }

        .shijian{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 12px;
            color: #999999;
            font-style: normal;
            text-transform: none;

            margin-left: 8px;
        }
    }

    .right{
        .el-button{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #D9276D;
            font-style: normal;
            text-transform: none;
        }
    }

    .huifuliuyan{
        margin-top: 8px;
        margin-bottom: 8px;
        margin-left: 52px;
        height: 38px;
        background: #F9F9F9;
        padding: 0 12px;
        display: inline-block;
        line-height: 38px;
        font-size: 12px;
        color: #999999;
    }
}

.fabiao{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 20px;
    .el-button{
        height: 40px;
        background: #D9276D;
        border-radius: 8px 8px 8px 8px;

        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        border: 0;
    }
}

.huifu{
    width: 420px;
    margin-left: 52px;
    margin-top: 8px;
    :deep(.el-textarea){
        width: 420px;
        height: 160px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        textarea{
            width: 420px;
            height: 160px;
            background: #F9F9F9;
            border: 0;
        }
    }

    .quxiao{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;

        background: none;
        border: 0;
    }
}

.blog-container {
    padding: 10px;
}

.fa-smile-o{
    font-size: 24px;
    margin-left: 12px;
    margin-right: 12px;
}
</style>